import { createTrackingEvent } from '@/common/analytics/gtm/createTrackingEvent';
import { type loginMethod } from '@/common/hooks/useClientStack/useClientStack';

export const trackUserLogin = (loginMethod: loginMethod): void => {
  const { loginMethod: method } = loginMethod;
  createTrackingEvent({
    event: 'login',
    login_method: method,
  });
};
